export const LOGBOOK_DAILY = 'daily'
export const LOGBOOK_REGULAR = 'regular'
export const LOGBOOK_FORM = 'logbook-form'
export const LOOGBOOK_ALL_TYPES = 'all-types'
export const DB_FISH_COUNT = 'fish-count'
export const DB_AVERAGE_WEIGHT = 'average-weight'
export const DB_BIOMASS = 'biomass'
export const DB_MORTALITY = 'mortality'
export const DB_MORTALITY_COUNT = 'mortality-count'
